import styled from 'styled-components';

export const Banner = styled.img`
  width: 100%;
  max-height: 800px;
  min-height: 200px;
  object-fit: cover;
`;

export const Title = styled.div`
  padding-top: 1.5em;

  h2 {
    text-align: center;
    font-weight: normal;
  }
`;

export const AboutUsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Paragraph = styled.p`
  font-size: 20px;
  max-width: 1000px;
  padding: 0 1em 1em;
  line-height: 1.5em;
`;

export const TitleBorderBottomContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TitleBorderBottom = styled.div`
  height: 3px;
  width: 60px;
  background-color: ${(props) => props.theme.colors.primary};
  margin: 1em 0 3em;
`;
